module.exports = __webpack_public_path__ + "static/20-841f071009c7a5b35ce4a6c1e652ebb5.jpg";